/**
 * 切屏监测
 */
import { useCallback, useEffect, useState } from "react";
import { useLatest } from "react-use";
import _ from "underscore";

interface SwitchPageDetectorProps {
    onSwitch: (count: number) => void;
}

export default function SwitchPageDetector({
    onSwitch
}: SwitchPageDetectorProps) {
    const [count, setCount] = useState(0);
    const countRef = useLatest(count);
    const onSwitchRef = useLatest(onSwitch);

    const handleVisibilityChange = useCallback(
        _.debounce(() => {
            setCount(count => count + 1);
            onSwitchRef.current(countRef.current);
        }, 200),
        []
    );

    useEffect(() => {
        let timeout: NodeJS.Timeout;

        function onVisibilityChange() {
            timeout = setTimeout(() => {
                if (document.hidden) handleVisibilityChange();
            }, 1000);
        }

        document.addEventListener("visibilitychange", onVisibilityChange);

        return () => {
            document.removeEventListener(
                "visibilitychange",
                onVisibilityChange
            );
            clearTimeout(timeout);
        };
    }, []);

    return null;
}
